/* eslint-disable react/style-prop-object */
import React, { useEffect, useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  FormErrorNotification,
  RadioInputGroup,
  RadioInput,
  Button,
  ButtonLink,
  useMediaQuery,
  FormLabel,
  requiredField,
  SubmitButton,
} from '@offerzen/pinata'

import ControlledHookField from '../../../../../CandidateExperience/components/ControlledHookField'
import SingleSelectFilter from '../../../SingleSelectFilter'
import styles from './styles'

export const WorkAuthFields = props => {
  const { allCountries } = props
  const [filteredCountries, setFilteredCountries] = useState(allCountries)

  useEffect(() => {
    setFilteredCountries(allCountries)
  }, [allCountries])

  const { isPhoneOrLarger } = useMediaQuery()

  const validators = {
    required: requiredField('Required'),
  }

  const hasErrors = !!Object.keys(props.errors).length

  return (
    <Fragment>
      <If condition={props.error}>
        <FormErrorNotification text={props.error} />
      </If>
      <div className={styles.workPermitSection}>
        <FormLabel htmlFor={`regionalCitizenships.${props.index}.country`} label="Country" />
        <ControlledHookField
          onChange={value => props.validateCountry(value, props.index)}
          control={props.control}
          component={SingleSelectFilter}
          id={`regionalCitizenships.${props.index}.country`}
          placeholder="Select a country"
          name={`regionalCitizenships.${props.index}.country`}
          className={styles.workPermitSectionField}
          validate={[validators.required, props.validateCountry]}
          results={filteredCountries}
        />
      </div>
      <ControlledHookField
        control={props.control}
        component={RadioInputGroup}
        name={`regionalCitizenships.${props.index}.citizenshipStatus`}
        label="Status"
        validate={validators.required}
        className={styles.citizenshipStatus}>
        <RadioInput value="PERMANENT_RESIDENT" label="Permanent resident (non-citizen)" className={styles.statusRadio} />
        <RadioInput value="WORK_PERMIT" label="Work permit/visa holder" className={styles.statusRadio} />
        <RadioInput value="NOT_AUTHORIZED_FOR_WORK" label="Not currently authorised to work" className={styles.statusRadio} />
      </ControlledHookField>
      <div className={styles.buttonContainer}>
        <Choose>
          <When condition={isPhoneOrLarger}>
            <ButtonLink
              className={styles.button}
              label="Cancel"
              theme="light"
              onClick={props.toggleFieldSection}
              disabled={props.isCreatingCitizenship}
            />
          </When>
          <Otherwise>
            <Button
              theme={props.theme}
              variant="outlined"
              size="medium"
              disabled={props.isCreatingCitizenship}
              label="Cancel"
              onClick={props.toggleFieldSection}
              className={styles.button}
            />
          </Otherwise>
        </Choose>

        <Choose>
          <When condition={props.isNewWorkAuth}>
            <SubmitButton
              isSubmitting={props.isCreatingCitizenship}
              label="Save"
              submittingLabel="Saving"
              id="work-auth-submit-btn"
              theme={props.theme}
              variant="outlined"
              className={styles.button}
              disabled={props.disableSubmit || hasErrors}
            />
          </When>
          <Otherwise>
            <SubmitButton
              isSubmitting={props.isUpdatingCitizenship}
              label="Save"
              submittingLabel="Saving"
              type="button"
              onClick={() => props.submitForm()}
              theme={props.theme}
              variant="outlined"
              className={styles.button}
              disabled={props.disableSubmit || hasErrors}
            />
          </Otherwise>
        </Choose>
      </div>
    </Fragment>
  )
}

const { bool, string, func, shape, number, arrayOf } = PropTypes

WorkAuthFields.propTypes = {
  error: string,
  allCountries: arrayOf(
    shape({
      label: string,
      value: string,
    }),
  ),
  toggleFieldSection: func,
  disableSubmit: bool,
  theme: string,
  isCreatingCitizenship: bool,
  isUpdatingCitizenship: bool,
  validateCountry: func.isRequired,
  control: shape().isRequired,
  errors: shape().isRequired,
  index: number.isRequired,
  isNewWorkAuth: bool,
  submitForm: func,
}
